"use client";

import React, { useState } from "react";
import { Box, styled, Typography } from "@mui/material";
import { Tag } from "@/ui";
import { SkillLogo } from "@components/shared/SkillLogo";
import {
  SectionHeader,
  SectionContent,
  RightColumn,
} from "./styles/SharedStyles";
import EditSkills from "../modals/EditSkills";
import EditButton from "@components/shared/EditButton";
import {
  useAddCandidateSkill,
  useRemoveCandidateSkill,
} from "@lib/candidates/useSkillMutations";
import { SkillsSkeleton } from "./skeletons/SkillsSkeleton";

const SkillsList = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
});

const Skills = ({ candidate, isImporting }) => {
  const [openEditSkills, setOpenEditSkills] = useState(false);
  const addSkill = useAddCandidateSkill();
  const removeSkill = useRemoveCandidateSkill();

  const handleAddSkill = (skill) => {
    addSkill.mutate({ candidate, skill });
  };

  const handleRemoveSkill = (skillId) => {
    removeSkill.mutate({ candidate, skillId });
  };

  return (
    <>
      <Box id="candidate-section-skills">
        <SectionContent>
          <EditButton
            onEdit={() => setOpenEditSkills(true)}
            sx={{ top: 0, right: 0 }}
          />
          <Box>
            <RightColumn>
              <SectionHeader>
                <Typography variant="h2">Skills</Typography>
              </SectionHeader>
              {isImporting ? (
                <SkillsSkeleton />
              ) : (
                <SkillsList>
                  {candidate.skills?.map((skill) => (
                    <Tag
                      key={skill.id}
                      variant="skill"
                      icon={
                        skill.logo && (
                          <SkillLogo
                            sx={{ width: 20, height: 20 }}
                            src={skill.logo}
                            variant="square"
                            title={skill.name}
                            alt={skill.name}
                          />
                        )
                      }
                    >
                      {skill.name}
                    </Tag>
                  ))}
                  {candidate.skills?.length === 0 && (
                    <Box sx={{ mt: 2, mb: 2, fontStyle: "italic" }}>
                      No skills selected
                    </Box>
                  )}
                </SkillsList>
              )}
            </RightColumn>
          </Box>
        </SectionContent>
      </Box>
      <EditSkills
        open={openEditSkills}
        onClose={() => setOpenEditSkills(false)}
        candidate={candidate}
        onAdd={handleAddSkill}
        onRemove={handleRemoveSkill}
      />
    </>
  );
};

export default Skills;
